import {ref} from 'vue';

import type {Nullable} from 'common/types/common';

export function useNullable<T>(value: Nullable<T> = null) {
    return ref<Nullable<T>>(value);
}
